import { ActionReducerMap } from '@ngrx/store';
import { ILoginState } from './login/login';
import { loginReducer } from './login/login.reducer';
import { IConfigState } from './config/config';
import { configReducer } from './config/config.reducer';
import { IClientActivitiesState } from './client-activities/client-activities';
import { clientActivitiesReducer } from './client-activities/client-activities.reducer';
import { ICourierActivitiesState } from './courier-activities/courier-activities';
import { courierActivitiesReducer } from './courier-activities/courier-activities.reducer';
import { IPackageWarehouseState } from './package-warehouse/package-warehouse';
import { packageWarehouseReducer } from './package-warehouse/package-warehouse.reducer';
import { IMessageState } from './messages/messages';
import { messagesReducer } from './messages/messages.reducer';
import { IConsumableWarehouseState } from './consumable-warehouse/consumable-warehouse';
import { consumableWarehouseReducer } from './consumable-warehouse/consumable-warehouse.reducer';
import { IPuntoPosteManagementState } from './punto-poste-management/punto-poste-management';
import { puntoPosteManagementReducer } from './punto-poste-management/punto-poste-management.reducer';
import { ICertificaEmailState } from './certifica-email/certifica-email';
import { certificaEmailReducer } from './certifica-email/certifica-email.reducer';
import { ILoginOtpState } from './login-otp/login-otp';
import { loginOtpReducer } from './login-otp/login-otp.reducer';
import { ICertificaCellulareState } from './certifica-cellulare/certifica-cellulare';
import { certificaCellulareReducer } from './certifica-cellulare/certifica-cellulare.reducer';

export interface AppState {
  config: IConfigState;
  login: ILoginState;
  clientActivities: IClientActivitiesState;
  courierActivities: ICourierActivitiesState;
  packageWarehouse: IPackageWarehouseState;
  consumableWarehouse: IConsumableWarehouseState;
  message: IMessageState;
  puntoPosteManagement: IPuntoPosteManagementState;
  certificaEmail: ICertificaEmailState;
  loginOtp: ILoginOtpState;
  certificaCellulare: ICertificaCellulareState;
}

export const rootReducers: ActionReducerMap<AppState> = {
  config: configReducer,
  login: loginReducer,
  clientActivities: clientActivitiesReducer,
  courierActivities: courierActivitiesReducer,
  packageWarehouse: packageWarehouseReducer,
  consumableWarehouse: consumableWarehouseReducer,
  message: messagesReducer,
  puntoPosteManagement: puntoPosteManagementReducer,
  certificaEmail: certificaEmailReducer,
  loginOtp: loginOtpReducer,
  certificaCellulare: certificaCellulareReducer,
};
